import { render, staticRenderFns } from "./leftTree.vue?vue&type=template&id=2ba9db22&scoped=true&"
import script from "./leftTree.vue?vue&type=script&lang=js&"
export * from "./leftTree.vue?vue&type=script&lang=js&"
import style0 from "./leftTree.vue?vue&type=style&index=0&id=2ba9db22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba9db22",
  null
  
)

export default component.exports